import { memo, PropsWithChildren } from 'react';
import classes from 'classnames';
import styles from './Row.module.scss';

export interface RowProps {
  className?: string;
}

export default memo(function Row({
  children,
  className,
}: PropsWithChildren<RowProps>) {
  return <div className={classes(styles.container, className)}>{children}</div>;
});
